import { unFormatCurrency, unFormatUnknownUnit } from "@/common/utils/unFormatters";
import { ProductCategoryGrantedCreditValidationSchema, ProductGrantedCreditValidationSchema } from "../schemas/createBranch.schema";
import { ControlledByType } from "../types/companyGovernmentAllocation.type";

export const transformNewProductCategoryGrantedCredit = (
  formProductCategory: ProductCategoryGrantedCreditValidationSchema,
  controlledBy?: ControlledByType,
) => {
  const isQuantity = controlledBy === 'quantity';
  return {
    product_category_id: formProductCategory.product_category_id,
    ...(isQuantity
      ? { granted_quantity: formProductCategory.granted_quantity && unFormatUnknownUnit(formProductCategory.granted_quantity) > 0 ? unFormatUnknownUnit(formProductCategory.granted_quantity) : 'null' }
      : { granted_credit: formProductCategory.granted_credit && unFormatCurrency(formProductCategory.granted_credit) > 0 ? unFormatCurrency(formProductCategory.granted_credit) : 'null' }),
    product_granted_credits_attributes: formProductCategory?.product_granted_credits_attributes?.map(
      (product) => transformNewProductGrantedCredit(product, controlledBy)
    ),
  };
};

export const transformNewProductGrantedCredit = (
  product: ProductGrantedCreditValidationSchema,
  controlledBy?: ControlledByType,
) => {
  const isQuantity = controlledBy === 'quantity';
  return {
    product_id: product.product_id,
    ...(isQuantity
      ? { granted_quantity: product.granted_quantity && unFormatUnknownUnit(product.granted_quantity) > 0 ? unFormatUnknownUnit(product.granted_quantity) : 'null' }
      : { granted_credit: product.granted_credit && unFormatCurrency(product.granted_credit) > 0 ? unFormatCurrency(product.granted_credit) : 'null' }),
  };
};

export const companyBranchErrorsTransformer = () => {
  return (errors: Record<string, string[]>) => {
    return Object.entries(errors).map(([key, value]) => {
      if (key.startsWith('restriction.')) {
        key = key.slice(12);
      }

      if (key.endsWith('.base')) {
        key = '_base';
      }

      return {
        [key]: value.join(', ')
      };
    });
  };
};
